(()=>{
  const context=document.querySelector('[data-imperial-discovery-context]');
  if(!context)return;

  const ctx=context.dataset.imperialDiscoveryContext||'';
  const handle=ctx.startsWith('collection-')?ctx.slice(11):'';
  const jewelleryHandles=new Set([
    'all-jewellery','rings','chains','necklaces','charms-pendants','bracelets','bangles','earrings','cufflinks','jewellery-accessories','wedding-bands',
    'mens-rings','mens-chains','mens-necklaces','mens-bracelets','mens-earrings','womens-rings','womens-necklaces','womens-bracelets','womens-earrings','unisex-bracelets','mens-jewellery','womens-jewellery','unisex-jewellery'
  ]);
  if(!jewelleryHandles.has(handle))return;

  document.documentElement.classList.add('imperial-jewellery-page','imperial-filter-system-v3');

  const norm=s=>(s||'').replace(/\s+/g,' ').trim().toLowerCase();
  const svg={
    availability:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 9.2 17 19 7"/></svg>',
    recipient:'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8" r="3"/><circle cx="16.5" cy="9" r="2.5"/><path d="M2.8 20c.4-4 2.3-6 5.2-6s4.8 2 5.2 6M13.5 15.2c.8-.8 1.8-1.2 3-1.2 2.5 0 4 1.7 4.5 5"/></svg>',
    metal:'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="12" r="5"/><circle cx="15" cy="12" r="5"/></svg>',
    purity:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 3 2 3.5.5.5 3.5 2 3-2 3-.5 3.5-3.5.5-3 2-3-2-3.5-.5-.5-3.5-2-3 2-3 .5-3.5 3.5-.5z"/><path d="m9.6 12 1.5 1.5 3.4-3.5"/></svg>',
    stone:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 9 4-5h8l4 5-8 11L4 9Z"/><path d="M4 9h16M8 4l4 5 4-5M8 9l4 11 4-11"/></svg>',
    size:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 16 16 4l4 4L8 20H4v-4Z"/><path d="m13 7 4 4M10 10l2 2M7 13l2 2"/></svg>',
    style:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 1.4 4.1L17.5 8.5l-4.1 1.4L12 14l-1.4-4.1-4.1-1.4 4.1-1.4L12 3ZM18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8L18 14Z"/></svg>',
    brand:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h9l7 7-8 8-8-8V5Z"/><circle cx="9" cy="10" r="1.5"/></svg>',
    filter:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>'
  };

  function facetKind(label){
    const l=norm(label);
    if(l.includes('availability'))return'availability';
    if(l.includes('price'))return'price';
    if(l.includes('gender')||l.includes('recipient')||l.includes('for him')||l.includes('for her'))return'recipient';
    if(l.includes('purity')||l.includes('karat')||l.includes('carat'))return'purity';
    if(l==='metal'||l.includes('metal type')||l.includes('material'))return'metal';
    if(l.includes('gem')||l.includes('stone'))return'stone';
    if(l.includes('size')||l.includes('length')||l.includes('width'))return'size';
    if(l.includes('style')||l.includes('finish')||l.includes('profile')||l==='type')return'style';
    if(l.includes('brand')||l.includes('vendor'))return'brand';
    return'filter';
  }

  function iconMarkup(kind){
    if(kind==='price')return'<span class="imperial-facet-icon__currency" aria-hidden="true">£</span>';
    return svg[kind]||svg.filter;
  }

  function visibleSummaryText(summary){
    const clone=summary.cloneNode(true);
    clone.querySelectorAll('.imperial-facet-icon,svg').forEach(el=>el.remove());
    return (clone.textContent||'').replace(/\(\d+\)/g,'').trim();
  }

  function decorateNativeFacets(root=document){
    root.querySelectorAll('#main-collection-filters details.js-filter>summary,.mobile-facets__details.js-filter>summary').forEach(summary=>{
      const text=visibleSummaryText(summary);
      const kind=facetKind(text);
      const wrap=summary.querySelector(':scope>div')||summary;
      let icon=wrap.querySelector(':scope>.imperial-facet-icon');
      if(!icon){
        icon=document.createElement('span');
        icon.className='imperial-facet-icon';
        icon.setAttribute('aria-hidden','true');
        wrap.prepend(icon);
      }
      icon.classList.add('imperial-facet-icon--v3');
      if(icon.dataset.imperialKind!==kind){
        icon.dataset.imperialKind=kind;
        icon.innerHTML=iconMarkup(kind);
      }
      const details=summary.closest('details.js-filter');
      if(details)details.dataset.imperialFacetKind=kind;

      if(kind==='recipient'){
        const candidates=[...wrap.querySelectorAll('span')].filter(el=>!el.classList.contains('imperial-facet-icon'));
        candidates.forEach(el=>{
          if(norm(el.textContent)==='gender')el.textContent='Recipient';
        });
      }
    });
  }

  function decorateFallback(root=document){
    root.querySelectorAll('.imperial-fallback-facet>summary').forEach(summary=>{
      const kind=facetKind(summary.textContent);
      let icon=summary.querySelector(':scope>.imperial-facet-icon');
      if(!icon){
        icon=document.createElement('span');
        icon.className='imperial-facet-icon';
        icon.setAttribute('aria-hidden','true');
        summary.prepend(icon);
      }
      icon.classList.add('imperial-facet-icon--v3');
      if(icon.dataset.imperialKind!==kind){
        icon.dataset.imperialKind=kind;
        icon.innerHTML=iconMarkup(kind);
      }
    });
  }

  function refineHeading(root=document){
    root.querySelectorAll('#main-collection-filters .facets__heading').forEach(el=>{
      const t=norm(el.textContent).replace(/:$/,'');
      if(t==='filter'||t==='filters')el.textContent='Refine';
    });
  }

  function decorateMobile(root=document){
    root.querySelectorAll('.mobile-facets__heading').forEach(el=>{
      const t=norm(el.textContent).replace(/:$/,'');
      if(t==='filter'||t==='filters')el.textContent='Refine';
    });
  }

  function run(){
    refineHeading();
    decorateNativeFacets();
    decorateFallback();
    decorateMobile();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  let queued=false;
  const observer=new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{
      queued=false;
      run();
    });
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',run);
})();
